module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAHdElNRQfkChsOLBnbbdVvAAAA8UlEQVQoz62SsWrCUBiFvyQgZJJkcXXqVFyE6lbBJxAcXTtIC04taPEJxKFz3dKtT+Ai7g6lS/c+QBIpCCKU08E01WsMGXruci//x/+fc++1vBITevicV0zAveNOGeCSJ5cGJcsLc7v9KrI8FcAAuxgGeNqvO4U6VajbpJ527Gda9emZo9uMiQzskxs6JjjngzpPbJNzyCNNHFamR0la6FqXetFGU1XV1bskJfUjUPrWq2qqqKVlGmhfT+/xz9+ON66wDgIBZICnyY/CbM5gX2bqB+IMbM0o2f3/W9s5KQ4V2QSFwJnjLihzkfvHY54Z/gAcXH7PbF/r9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/about/youxiang.png
// module id = HOv6
// module chunks = 1